import React from 'react';
import { Link } from 'react-router-dom';
import {
  EnvelopeIcon,
  MapPinIcon,
  PhotoIcon
} from '@heroicons/react/24/outline';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    'Products': [
      { name: 'Business Tools', path: '/products?category=Business Tools' },
      { name: 'Security', path: '/products?category=Security' },
      { name: 'Development', path: '/products?category=Development' },
      { name: 'Design', path: '/products?category=Design' }
    ],
    'Company': [
      { name: 'About Us', path: '/about' },
      { name: 'Contact', path: '/contact' },
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Terms of Service', path: '/terms' }
    ],
    'Support': [
      { name: 'Help Center', path: '/help' },
      { name: 'Documentation', path: '/docs' },
      { name: 'API Reference', path: '/api' },
      { name: 'Status', path: '/status' }
    ]
  };

  return (
    <footer className="bg-secondary border-t-4 border-primary mt-auto relative z-40">
      <div className="container py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-6">
            <h3 className="text-3xl font-black text-black uppercase tracking-tighter" style={{textShadow: '2px 2px 0px #9FE240'}}>Asset Store</h3>
            <p className="text-black font-medium border-l-4 border-primary pl-4 bg-secondary/50 py-2">
              Your trusted marketplace for premium digital assets and tools.
            </p>
            <div className="space-y-4 font-bold">
              <div className="flex items-center gap-3 text-black">
                <div className="bg-primary text-black p-1 border-2 border-black shadow-[2px_2px_0px_0px_#000000]">
                  <EnvelopeIcon className="h-5 w-5" />
                </div>
                <span>pingfence@gmail.com</span>
              </div>
              <a
                href="https://ig.me/m/pingfence"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-black hover:text-primary transition-colors no-underline"
              >
                <div className="bg-primary text-black p-1 border-2 border-black shadow-[2px_2px_0px_0px_#000000]">
                  <PhotoIcon className="h-5 w-5" />
                </div>
                <span>@PINGFENCE</span>
              </a>
              <div className="flex items-center gap-3 text-black">
                <div className="bg-primary text-black p-1 border-2 border-black shadow-[2px_2px_0px_0px_#000000]">
                  <MapPinIcon className="h-5 w-5" />
                </div>
                <span>123 Tech Street, Digital City</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-xl font-black text-primary mb-6 uppercase tracking-wider border-b-2 border-primary inline-block pb-1">{title}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-black font-bold hover:text-primary hover:translate-x-2 transition-all inline-block uppercase text-sm tracking-wide"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Brutalist Divider */}
        <div className="h-1 bg-primary mb-8 w-full shadow-[4px_4px_0px_0px_#000000]"></div>

        {/* Copyright Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-black font-bold bg-primary px-4 py-2 border-2 border-black shadow-[4px_4px_0px_0px_#000000]">
            © {currentYear} Pingfence. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-black font-bold hover:text-primary uppercase tracking-wide text-sm border-b-2 border-transparent hover:border-primary transition-all">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-black font-bold hover:text-primary uppercase tracking-wide text-sm border-b-2 border-transparent hover:border-primary transition-all">
              Terms of Service
            </Link>
            <Link to="/cookies" className="text-black font-bold hover:text-primary uppercase tracking-wide text-sm border-b-2 border-transparent hover:border-primary transition-all">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 